import { InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/NavBar";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import DentalConsultationPageFormPresenter from "./DentalConsultationPageFormPresenter";

class DentalConsultationPageForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new DentalConsultationPageFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.object.employee !== this.state.object.employee) {
  //     console.log("CHANGEOBJ:");
  //   }
  // }

  getCollectionName() {
    return "dental_consultation";
  }

  onChange(value, field) {
    // if (field === "employee") {
    //   this.setEmployeeData(value);
    // }
    this.presenter.onChange(value, field);
  }

  // async setEmployeeData(value) {
  //   const employee = await findObjectUseCase().execute("employees", {
  //     where: { id: value.id },
  //   });
  //   console.log("EMPL: ", employee);
  //   this.state.object.dateOfBirth = employee[0].birthDate;
  //   this.state.object.gender = employee[0].sex;
  //   this.state.object.contactDetails = employee[0].mobile;
  //   this.state.object.philhealthNumber = employee[0].philhealth;
  //   // this.state.object.department = employee[0].barangay;
  //   this.presenter.onChange(employee[0].sex, "gender");
  // }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  async handleFormSubmit() {
    await upsertUseCase().execute(this.getCollectionName(), this.state.object);
    this.navigateBack();
    this.showSuccess("Success");
  }

  render() {
    const object = this.state.object;
    console.log("ob", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    const path = this.props.location.pathname;
    const isViewMode = path.startsWith("/view/");
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleFormSubmit();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        className="col-lg-6"
                        object={object}
                        disabled={isViewMode}
                        onChange={this.onChange.bind(this)}
                      />
                    )}
                  </div>
                  <div className="mt-4">
                    {!isViewMode && (
                      <button
                        type="submit"
                        className="btn btn-primary fs-sm me-3"
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        {label}
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(DentalConsultationPageForm);
